export const Environment = {
  production: false,
  devDiagnosticsEnabled: true,
  apiUrl: 'https://enrich.muk.i234.me',
  authUIUrlPath:'v1/auth-ui',
  promptTemplates:'v1/prompt-templates',
  llmConfigurationUrlPath:'v1/llm-configuration',
  enrichUrlPath:'v1/enrich',
  enrichStreamUrlPath:'v1/enrich/stream',
  patientCardsUrlPath:'v1/patient-cards',
  devEnrichmentLogsUrlPath:'v1/dev/enrichment-logs',
};
